import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useForm, Controller } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { signinUser, verifyTwoFactor, getPin } from '../../../actions/auths';
import { fetchUser } from '../../../actions/user';

const VerifyPin = ({
  two_factor,
  authenticated,
  history,
  errorMessage,
  verifyTwoFactor,
  fetchUser,
  getPin,
}) => {
  const { control, handleSubmit } = useForm({ defaultValues: { code: '' } });

  const [resentMessage, setResentMessage] = useState('');
  const location = useLocation();

  // store email + id in state so they can be updated
  const [email] = useState(location.state?.email);
  const [id, setId] = useState(location.state?.id);

  // Redirect logic
  useEffect(() => {
    if (authenticated) {
      history.push('/dashboard');
    } else if (!two_factor) {
      history.push('/signin');
    }
  }, [authenticated, two_factor, history]);

  const onSubmit = async values => {
    verifyTwoFactor({ ...values, id, email }, () => fetchUser());
  };

  const resetPin = () => {
    getPin({ email }, response => {
      // assume backend returns new ID inside response.id
      if (response?.data?.two_factor_id) {
        setId(response?.data?.two_factor_id); // 👈 update id
      }

      setResentMessage(
        <FormattedMessage defaultMessage="Your new pin was successfully sent." />,
      );
    });
  };

  const normalizePin = value => {
    if (!value) return value;
    const onlyNums = value.replace(/[^\d]/g, '');
    return onlyNums.slice(0, 7);
  };

  return (
    <div className="signin-container">
      <div className="row">
        <div className="col" style={{ minWidth: 376 }}>
          <div className="auth-form center-items">
            <h4>
              <FormattedMessage defaultMessage="Verify Access" />
            </h4>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="verify-wrapper">
                <p className="auth-paragraph">
                  <FormattedMessage defaultMessage="An extra security layer has been added to ensure it's you" />
                </p>
                <p className="auth-paragraph">
                  <FormattedMessage defaultMessage="Enter the 7 digit pin sent to your email" />
                </p>

                <div className="pin-verify-input">
                  <Controller
                    name="code"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="text"
                        {...field}
                        onChange={e =>
                          field.onChange(normalizePin(e.target.value))
                        }
                        maxLength={7}
                      />
                    )}
                  />
                </div>

                <p className="signin-link-text">
                  <FormattedMessage defaultMessage="Didn't get the pin?" />{' '}
                  <span role="button" onClick={resetPin}>
                    <FormattedMessage defaultMessage="Resend" />
                  </span>
                </p>

                {errorMessage && (
                  <p className="signin-link-text error-text">{errorMessage}</p>
                )}
                {resentMessage && (
                  <p className="signin-link-text success">{resentMessage}</p>
                )}

                <button
                  type="submit"
                  style={{ margin: '0 auto', cursor: 'pointer' }}
                  className="signin-button"
                >
                  <FormattedMessage defaultMessage="Sign In" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

VerifyPin.propTypes = {
  two_factor: PropTypes.bool,
  authenticated: PropTypes.bool,
  history: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
  verifyTwoFactor: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  getPin: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    two_factor: state.auth.two_factor,
    authenticated: state.auth.authenticated,
    errorMessage: state.auth.error,
  };
}

export default connect(mapStateToProps, {
  signinUser,
  fetchUser,
  verifyTwoFactor,
  getPin,
})(VerifyPin);
